import {call, put, takeEvery} from 'redux-saga/effects' 
import axios from 'axios'
import querystring from 'querystring';
import {
    FETCH_RESOURCE_LOADED,
    FETCH_RESOURCE_ERROR,
} from '../actions/auxiliar_actions'

import {
    FETCH_LOGIN,
    FETCH_LOGIN_SUCCESS,
    FETCH_RENEW_PASSWORD,
    FETCH_RENEW_PASSWORD_SUCCESS
} from '../actions/auth_actions'
import { login, refreshToken } from '../services/auth_services.js';

function* fetchLoginSaga({payload}){
    try {
        const loginResponse = yield call(login, payload.params.emailLogin, payload.params.passwordLogin)
        console.log(loginResponse)
        if(loginResponse && loginResponse.status === 200){
            // let data ={}
            // data.token = resTokenLogin.data;
            // console.log(loginResponse)
            yield put({type: FETCH_LOGIN_SUCCESS, payload: loginResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            yield put({type: FETCH_RESOURCE_ERROR, payload: "Authentication failed"})
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchRenewPasswordSaga({payload}){
    try {
        console.log(payload)
        const refreshResponse = yield call(refreshToken, payload.params)
        console.log(refreshResponse)
        if(refreshResponse.status === 200){
            // let data ={}
            // data.token = resTokenLogin.data;
            // console.log(refreshResponse)
            yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* watchLoginSagas(){
    yield takeEvery(FETCH_LOGIN, fetchLoginSaga)
}

function* watchRenewPasswordSagas(){
    yield takeEvery(FETCH_RENEW_PASSWORD, fetchRenewPasswordSaga)
}

export default [watchLoginSagas, watchRenewPasswordSagas]